import { Breadcrumb, Button, Card, Col, Divider, Empty, message, Modal, Row, Select } from 'antd';
import FormItem from 'antd/lib/form/FormItem';
import TextArea from 'antd/lib/input/TextArea';
import gql from 'graphql-tag';
import React, { Component } from 'react';
import { Mutation, Query } from 'react-apollo';
import { Link } from 'react-router-dom';

import { WorkOrder, WorkOrderPriority, WorkOrderStatus } from './type';
import { WorkOrderPriorityList, workOrdersQuery, WorkOrderStatusList, WorkOrderTypeList } from './WorkOrderList';

export const updateWorkOrderStatusMutation = gql`
  mutation updateWorkOrderStatus($id: ID!, $status: Int!, $remark: String) {
    updateWorkOrderStatus(id: $id, status: $status, remark: $remark) {
      id
      status
    }
  }
`;

export const updateWorkOrderPriorityMutation = gql`
  mutation updateWorkOrderPriority($id: ID!, $priority: Int!) {
    updateWorkOrderPriority(id: $id, priority: $priority) {
      id
      status
    }
  }
`;

interface Props {
  match: any;
}

interface WorkOrderListData {
  workOrders: WorkOrder[];
}

interface State {
  isUpdateWorkOrderStatusPopupModalVisible: boolean;
  isUpdateWorkOrderPriorityPopupModalVisible: boolean;
  priority?: WorkOrderPriority;
  remark?: string;
  status?: WorkOrderStatus;
}

export class WorkOrderDetail extends Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      isUpdateWorkOrderStatusPopupModalVisible: false,
      isUpdateWorkOrderPriorityPopupModalVisible: false,
    };
  }

  showUpdateWorkOrderStatusModal = () => {
    this.setState({
      isUpdateWorkOrderStatusPopupModalVisible: true,
    });
  };

  showUpdateWorkOrderPriorityModal = () => {
    this.setState({
      isUpdateWorkOrderPriorityPopupModalVisible: true,
    });
  };

  closeUpdateWorkOrderStatusModal = () => {
    this.setState({
      isUpdateWorkOrderStatusPopupModalVisible: false,
    });
  };

  closeUpdateWorkOrderPriorityModal = () => {
    this.setState({
      isUpdateWorkOrderPriorityPopupModalVisible: false,
    });
  };

  onRemarkChange(e: { target: { value: string } }) {
    this.setState({ remark: e.target.value });
  }
  render() {
    const { priority, remark, status } = this.state;
    return (
      <>
        <Breadcrumb style={{ marginBottom: 10, fontSize: 13 }}>
          <Breadcrumb.Item>
            <Link to={`/Home`}>首页</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to={`/work-order/list`}>工单列表</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>工单详情</Breadcrumb.Item>
        </Breadcrumb>
        <Query<WorkOrderListData> query={workOrdersQuery} variables={{ ids: [this.props.match.params.id] }}>
          {({ loading, error, data }) => {
            if (error) return <div>{error.message}</div>;
            if (loading) return <div>loading...</div>;
            if (!data) {
              // @ts-ignore
              return <Empty />;
            }
            const { workOrders } = data;

            const [workOrder] = workOrders;
            return (
              <Card>
                <Row gutter={24}>
                  <h2>{workOrder.title}</h2>
                </Row>

                <Divider style={{ marginTop: '8px', marginBottom: '8px' }} />
                <Row gutter={24}>
                  <Col span={5} style={{ textAlign: 'right' }}>
                    工单号：
                  </Col>
                  <Col span={7}>{workOrder.id}</Col>

                  <Col span={5} style={{ textAlign: 'right' }}>
                    分类：
                  </Col>
                  <Col span={7}>{WorkOrderTypeList[workOrder.type]}</Col>
                </Row>
                <Row gutter={24}>
                  <Col span={5} style={{ textAlign: 'right' }}>
                    状态：
                  </Col>
                  <Col span={7}>{WorkOrderStatusList[workOrder.status]}</Col>

                  <Col span={5} style={{ textAlign: 'right' }}>
                    优先级：
                  </Col>

                  <Col span={7}>{WorkOrderPriorityList[workOrder.priority]}</Col>
                </Row>
                <Row gutter={24}>
                  <Col span={5} style={{ textAlign: 'right' }}>
                    amount:
                  </Col>
                  <Col span={7}>{workOrder.metadata.amount}</Col>
                  <Col span={5} style={{ textAlign: 'right' }}>
                    reason:
                  </Col>
                  <Col span={7}>{workOrder.metadata.reason}</Col>
                </Row>
                <TextArea
                  placeholder="请输入留言"
                  autosize={{ minRows: 5 }}
                  value={this.state.remark}
                  onChange={e => this.onRemarkChange(e)}
                  style={{ marginBottom: 26 }}
                />
                <Row style={{ marginTop: 8 }}>
                  <FormItem label={`工单状态`}>
                    <Col xs={24} md={24} lg={8} xl={8} xxl={8}>
                      <Select
                        placeholder="请选择工单状态"
                        style={{ width: '100%' }}
                        allowClear
                        onChange={value => {
                          this.setState({
                            status: Number(value),
                          });
                        }}
                      >
                        {Object.keys(WorkOrderStatusList).map(status => {
                          return (
                            <Select.Option key={status} value={status}>
                              {WorkOrderStatusList[status]}
                            </Select.Option>
                          );
                        })}
                      </Select>
                    </Col>
                  </FormItem>

                  <Col span={24} style={{ textAlign: 'right' }}>
                    <Button style={{ marginRight: 8 }} type="primary" onClick={this.showUpdateWorkOrderStatusModal}>
                      确定
                    </Button>
                  </Col>
                </Row>
                <Divider style={{ marginTop: '8px', marginBottom: '8px' }} />
                <Row style={{ marginTop: 8 }}>
                  <FormItem label={`工单优先级`}>
                    <Col xs={24} md={24} lg={8} xl={8} xxl={8}>
                      <Select
                        placeholder="请选择工单优先级"
                        allowClear
                        style={{ width: '100%' }}
                        onChange={value => {
                          this.setState({
                            priority: Number(value),
                          });
                        }}
                      >
                        {Object.keys(WorkOrderPriorityList).map(priority => {
                          return (
                            <Select.Option key={priority} value={priority}>
                              {WorkOrderPriorityList[priority]}
                            </Select.Option>
                          );
                        })}
                      </Select>
                    </Col>
                  </FormItem>

                  <Col span={24} style={{ textAlign: 'right' }}>
                    <Button style={{ marginRight: 8 }} type="primary" onClick={this.showUpdateWorkOrderPriorityModal}>
                      确定
                    </Button>
                  </Col>
                </Row>
                <Mutation
                  mutation={updateWorkOrderStatusMutation}
                  variables={{
                    remark,
                    status,
                    id: this.props.match.params.id,
                  }}
                  refetchQueries={[
                    {
                      query: workOrdersQuery,
                      variables: { ids: [this.props.match.params.id] },
                    },
                  ]}
                >
                  {(updateWorkOrderStatus, { loading }) => {
                    return (
                      <Modal
                        visible={this.state.isUpdateWorkOrderStatusPopupModalVisible}
                        onOk={async () => {
                          if (loading) {
                            return;
                          }
                          try {
                            await updateWorkOrderStatus();
                            message.success('操作成功');
                            this.setState({ isUpdateWorkOrderStatusPopupModalVisible: false });
                          } catch (error) {
                            const [err] = error.graphQLErrors;
                            message.error(err.message);
                          }
                        }}
                        onCancel={this.closeUpdateWorkOrderStatusModal}
                      >
                        <p>确定修改工单状态操作？</p>
                      </Modal>
                    );
                  }}
                </Mutation>

                <Mutation
                  mutation={updateWorkOrderPriorityMutation}
                  variables={{
                    priority,
                    id: this.props.match.params.id,
                  }}
                  refetchQueries={[
                    {
                      query: workOrdersQuery,
                      variables: { ids: [this.props.match.params.id] },
                    },
                  ]}
                >
                  {(updateWorkOrderPriority, { loading }) => {
                    return (
                      <Modal
                        visible={this.state.isUpdateWorkOrderPriorityPopupModalVisible}
                        onOk={async () => {
                          if (loading) {
                            return;
                          }
                          try {
                            await updateWorkOrderPriority();
                            message.success('操作成功');
                            this.setState({ isUpdateWorkOrderPriorityPopupModalVisible: false });
                          } catch (error) {
                            const [err] = error.graphQLErrors;
                            message.error(err.message);
                          }
                        }}
                        onCancel={this.closeUpdateWorkOrderPriorityModal}
                      >
                        <p>确定修改工单优先级？</p>
                      </Modal>
                    );
                  }}
                </Mutation>

                <Divider style={{ marginTop: '8px', marginBottom: '8px' }} />

                <Card title="工单记录" type="inner" style={{ marginTop: '20px' }}>
                  {workOrder.histories.map((result, index) => {
                    return <Card key={index}>{result.description}</Card>;
                  })}
                </Card>
              </Card>
            );
          }}
        </Query>
      </>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/workOrder/WorkOrderDetail.tsx